import { alpha } from '@mui/material/styles';

import * as palette from '../palette';

/**
 * Returns the box-shadow value for a Tab that is used to indicate selected and/or hovered states.
 */
const tabBoxShadow = (color: string = palette.Primary.main) => `0 -2px 0 ${color} inset`;

const TabHorizontalPadding = 14;
const TabVerticalPadding = 14;
const TabLineHeight = 18;
const TabTopPaddingOffset = 4;

/**
 * Hides the default MUI Tabs indicator (the underline below the active tab).  This indicator is
 * applied at the overall Tabs level, and the style definitions below apply the indicator at the
 * individual Tab level as it is easier to target and manage based on the Tab's state.
 */
const TabsIndicatorOverride = {
  '& .MuiTabs-indicator': {
    display: 'none',
  },
};

export const TabStyleOverrides = {
  '&.Mui-selected': {
    backgroundColor: 'transparent',
  },
  '&.Mui-selected:hover': {
    backgroundColor: alpha(palette.Primary.main, 0.02),
  },
  '&.Mui-selected:not(:focus-visible)': {
    boxShadow: tabBoxShadow(),
  },
  '&:focus-visible': {
    boxShadow: 'none',
    outline: `2px solid ${palette.Secondary.main}`,
  },
  ':hover:not(:focus-visible):not(.Mui-selected)': {
    backgroundColor: alpha(palette.Primary.main, 0.01),
    boxShadow: tabBoxShadow(alpha(palette.Primary.main, 0.12)),
  },
  border: 'none',
  borderTopLeftRadius: '4px',
  borderTopRightRadius: '4px',
  lineHeight: `${TabLineHeight}px`,
  minHeight: `${TabLineHeight + TabVerticalPadding * 2 - TabTopPaddingOffset}px`,
  outline: '2px solid transparent',
  outlineOffset: '-2px',
  padding: [
    `${TabVerticalPadding - TabTopPaddingOffset}px`,
    `${TabHorizontalPadding}px`,
    `${TabVerticalPadding}px`,
    `${TabHorizontalPadding}px`,
  ].join(' '),
};

export const TabsStyleOverrides = {
  ...TabsIndicatorOverride,
  minHeight: `${TabLineHeight + TabVerticalPadding * 2 - TabTopPaddingOffset}px`,
};
